<template>
  <div class="check-work-body d-flex">
    <div class="d-flex-left">
      <erp-tree-status @node-click="nodeClick" />
    </div>
    <div class="d-flex-right">
      <transition name="slide-fade" mode="out-in">
        <keep-alive>
          <component :is="componentId"/>
        </keep-alive>
      </transition>
    </div>
  </div>
</template>

<script>
import ErpTreeStatus from "../Common/erp-tree-status";
import MeterNoteMain from "./components/meter_note/MeterNoteMain"
export default {
  name: "MeterNote",
  components: {ErpTreeStatus,MeterNoteMain},
  provide(){
    return{
      mainObj:this.mainObj,
      componentId:this.componentId,
      setComponentId:this.setComponentId,
    }
  },
  data(){
    return{
      mainObj:{
        house_name:"",
        house_id:"",
        project_id:"",
        id:""
      },
      componentId:"MeterNoteMain",
    }
  },
  methods:{
    nodeClick(data) {
      const that=this;
      that.mainObj.house_name = data.tree
        .map((ret) => {
          return ret.name;
        })
        .join("->");
      that.mainObj.project_id = data.tree[0].pindex_id;
      if (data.tree[data.tree.length - 1].type === "room") {
        that.mainObj.house_id = data.tree[data.tree.length - 1].id;
      } else {
        that.mainObj.house_id = 0;
      }
    },
    setComponentId(componentId){
      this.componentId=componentId;
    },
  },
}
</script>

<style lang="scss" scoped>
@import "common";
.d-flex {
  display: flex;
  margin: 10px;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  flex: 1;
  overflow-x:hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/MeterNote.vue